import { useEffect } from "react";

const SITE_URL = process.env.REACT_APP_SITE_URL || "https://nematv.com";

const setMeta = (attr, key, val) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", val);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

const setJsonLd = (id, data) => {
  const existing = document.getElementById(id);
  if (existing) existing.remove();
  const s = document.createElement("script");
  s.type = "application/ld+json";
  s.id = id;
  s.text = JSON.stringify(data);
  document.head.appendChild(s);
};

const Seo = ({ title, description, path = "/", schemas = [], image, noindex = false, keywords }) => {
  useEffect(() => {
    const canonical = `${SITE_URL}${path}`;
    const img = image || `${SITE_URL}/og-image.jpg`;

    document.title = title;
    setMeta("name", "description", description);
    if (keywords) setMeta("name", "keywords", keywords);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setLink("canonical", canonical);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:image", img);
    setMeta("property", "og:site_name", "Nema TV");
    setMeta("property", "og:locale", "en_US");
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);

    setJsonLd("ld-organization", {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Nema TV",
      url: SITE_URL,
      logo: `${SITE_URL}/apple-touch-icon.png`,
      sameAs: [],
    });
    setJsonLd("ld-website", {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "Nema TV",
      url: SITE_URL,
    });

    ["ld-page-1", "ld-page-2", "ld-page-3"].forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.remove();
    });
    schemas.slice(0, 3).forEach((data, i) => {
      setJsonLd(`ld-page-${i + 1}`, data);
    });
  }, [title, description, path, JSON.stringify(schemas), image, noindex, keywords]);
  return null;
};

export default Seo;
